import { validateIsEmail } from './validateIsEmail';

export const extractLocalPart = email => {
  const localPart = validateIsEmail(email) ? email.split('@')[0] : '';
  return localPart;
};
